// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "loyalty-2TI-b";
var _3 = "loyalty__header-JAF8e";
var _4 = "loyalty__name-BFwfc";
var _5 = "loyalty__miles-2ryBX";
var _6 = "loyalty__hint-3Z5zE";
var _7 = "loyalty__content-6Q1RE";
export { _1 as "__esModule", _2 as "loyalty", _3 as "loyalty__header", _4 as "loyalty__name", _5 as "loyalty__miles", _6 as "loyalty__hint", _7 as "loyalty__content" }
export default { "__esModule": _1, "loyalty": _2, "loyalty__header": _3, "loyalty__name": _4, "loyalty__miles": _5, "loyalty__hint": _6, "loyalty__content": _7 }
